import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MojoAvatarModule } from 'mojo-avatar';

import { SharedDirectivesModule } from '@shared/directives';
import { ImageUploadModule } from '@shared/image-upload/image-upload.module';
import { LocationInputModule } from '@shared/location/location-input.module';

import { CandidateSourceModule } from './+source/candidate-source.module';
import { CandidateDetailsRoutingModule } from './candidate-details-routing.module';
import { CandidateDetailsModalComponent } from './containers/candidate-details-modal.container';
import { CandidateDetailsComponent } from './containers/candidate-details.container';

const containers = [CandidateDetailsComponent, CandidateDetailsModalComponent];

@NgModule({
  imports: [
    ImageUploadModule,
    LocationInputModule,
    SharedDirectivesModule,
    CommonModule,
    ReactiveFormsModule,
    MojoAvatarModule,
    CandidateDetailsRoutingModule,
    CandidateSourceModule,
    MatButtonModule,
  ],
  declarations: [...containers],
  exports: [...containers],
})
export class CandidateDetailsModule {}
